import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import { OpportunityStageForNonMember } from '@fitness-force/enum';
import { Store } from '@ngrx/store';
import { STAGE_MASTER_STATE } from '@fitness-force/state';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'opportunity-stage',
  templateUrl: './opportunity-stage.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ButtonModule, RippleModule, StyleClassModule],
})
export class OpportunityStageComponent implements OnInit {
  private store = inject(Store);

  columnData: Observable<any> = new BehaviorSubject(null);
  stage!: any;

  ngOnInit(): void {
    this.columnData.subscribe({
      next: (stage: any) => {
        if (stage.stage_master_id) {
          this.setStage(stage.stage_master_id);
        } else if (
          stage.opp_stage_mst_name_pri_lang ||
          stage.opp_stage_mst_name_sec_lang
        ) {
          this.stage = stage.opp_stage_mst_name_pri_lang
            ? stage.opp_stage_mst_name_pri_lang
                .replace(/([A-Z])/g, ' $1')
                .trim()
            : stage.opp_stage_mst_name_sec_lang
                .replace(/([A-Z])/g, ' $1')
                .trim();
        } else {
          this.stage = null;
        }
      },
      error: (error: any) => {},
    });
  }

  setStage(stageId: number) {
    this.store.select(STAGE_MASTER_STATE).subscribe({
      next: (stages: any) => {
        let temp = stages.find((value: any) => value.id == stageId);
        // to show capital Letters with space
        this.stage = temp?.name_primary_language
          .replace(/([A-Z])/g, ' $1')
          .trim();
      },
      error: (error: any) => {},
    });
  }
}
